// NEW_FILE_JUSTIFIED: New component for drivers list section — wraps DriverCard array with add button, no existing equivalent
import { DriverCard } from '@/components/insurance/DriverCard';
import type { IDriversSectionProps } from '@/@types/insurance';

export function DriversSection({
  drivers,
  onUpdate,
  onSetFile,
  onRemoveFile,
  onRemove,
  mainDriverIndex,
  onSetMainDriver,
  disabled,
}: IDriversSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      {drivers.length === 0 && (
        <p className="text-sm text-muted-foreground py-2">
          No drivers added yet. Click &quot;Add Driver&quot; to add one.
        </p>
      )}

      {drivers.map((driver, index) => (
        <DriverCard
          key={index}
          index={index}
          driver={driver}
          onUpdate={onUpdate}
          onSetFile={onSetFile}
          onRemoveFile={onRemoveFile}
          onRemove={onRemove}
          isMainDriver={mainDriverIndex === index}
          onSetMainDriver={() => onSetMainDriver(index)}
          showMainDriverSelector={drivers.length > 1}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
